import { Text as RadixText } from '@radix-ui/themes'
import { forwardRef } from 'react'
import type { ComponentPropsWithoutRef } from 'react'

type TextProps = ComponentPropsWithoutRef<typeof RadixText>

export const Text = forwardRef<HTMLSpanElement, TextProps>(
  ({ className = '', ...props }, ref) => {
    return <RadixText className={className} ref={ref} {...props} />
  }
)

Text.displayName = 'Text'
